@if (isRmbRmc) {
<p>{{ "OTHER_COVERAGE_STATICTEXT14" | globalTranslate }}</p>
}
<p class="person-label">{{ selectedIndividual | fullname }}</p>

<nh-form
  [topLevelName]="'otex'"
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  topLevelQuestion="{{ 'OTHER_COVERAGE_STATICTEXT2' | globalTranslate }}"
  [individualQuestion]="'OTHER_COVERAGE_RMB_SUMMARY_STATIC1' | globalTranslate"
  [individualQuestionAria]="
    this.translateService.getDefaultLang() === 'en'
      ? (this.individualQuesAriaEn | globalTranslate)
      : this.individualQuesAriaSp
  "
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "OTHER_COVERAGE_STATICTEXT1" | globalTranslate }}
    </h1>
    <hr />
    <p>{{ "OTHER_COVERAGE_STATICTEXT4" | globalTranslate }}</p>

    <nh-field
      id="otex_insuranceCompanyName"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'NAME' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="insuranceCompanyName"
        [attr.aria-labelledby]="'otex_insuranceCompanyName'"
        formControlName="insuranceCompanyName"
        class="form-control"
      />
    </nh-field>

    <nh-field
      id="otex_phoneNumber"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'PHONE_NUMBER1' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="phoneNumber"
        [attr.aria-labelledby]="'otex_phoneNumber'"
        formControlName="phoneNumber"
        class="form-control"
        mask="000-000-0000"
        placeholder="XXX-XXX-XXXX"
      />
    </nh-field>

    <nh-field
      id="otex_emailId"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'EMAIL_ADDRESS' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="email"
        name="emailId"
        [attr.aria-labelledby]="'otex_emailId'"
        class="form-control"
        formControlName="emailId"
      />
    </nh-field>

    <nh-field
      id="otex_minRequirementMetSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_COVERAGE_STATICTEXT5' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_COVERAGE_STATICTEXT6' | globalTranslate"
      ></nh-popover>
      <select
        nhTranslate
        name="minRequirementMetSw"
        [attr.aria-label]="'OTHER_COVERAGE_STATICTEXT5' | globalTranslate"
        [items]="tableCodeValue('YESNO', 'data.minRequirementMetSw')"
        formControlName="minRequirementMetSw"
      ></select>
    </nh-field>

    <nh-field
      id="otex_policyPremiumAmount"
      label="{{ 'OTHER_COVERAGE_STATICTEXT7' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_COVERAGE_STATICTEXT10' | globalTranslate"
      ></nh-popover>
      <nh-input-group prepend="$">
        <input
          nh
          type="decimal"
          maxlength="7"
          name="policyPremiumAmount"
          [attr.aria-label]="'OTHER_COVERAGE_STATICTEXT7' | globalTranslate"
          formControlName="policyPremiumAmount"
          class="form-control"
          required
        />
      </nh-input-group>
    </nh-field>

    <nh-field
      id="otex_premiumFreqCd"
      label="{{ 'OTHER_COVERAGE_STATICTEXT9' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="premiumFreqCd"
        [attr.aria-labelledby]="'otex_premiumFreqCd'"
        [items]="tableCodeValue('INCEXPPAYFREQUENCY', 'data.premiumFreqCd')"
        formControlName="premiumFreqCd"
        required
      ></select>
    </nh-field>

    <nh-field
      id="otex_cobraSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_COVERAGE_STATICTEXT8' | globalTranslate }}"
      class="label-section"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_COVERAGE_STATICTEXT11' | globalTranslate"
      ></nh-popover>
      <select
        nhTranslate
        name="cobraSw"
        [attr.aria-label]="'OTHER_COVERAGE_STATICTEXT8' | globalTranslate"
        [items]="tableCodeValue('YESNO', 'data.cobraSw')"
        formControlName="cobraSw"
      ></select>
    </nh-field>

    <nh-field
      id="otex_retireeSw"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_COVERAGE_STATICTEXT12' | globalTranslate }}"
      class="label-section"
      [col9]="true"
    >
      <nh-popover
        class="ps-1"
        [content]="'OTHER_COVERAGE_STATICTEXT13' | globalTranslate"
      ></nh-popover>
      <select
        nhTranslate
        name="retireeSw"
        [attr.aria-label]="'OTHER_COVERAGE_STATICTEXT12' | globalTranslate"
        [items]="tableCodeValue('YESNO', 'data.retireeSw')"
        formControlName="retireeSw"
      ></select>
    </nh-field>
  </section>
</nh-form>